import { ITypedReduxAction } from '../../types/redux/actionType';
import { EPaymentInitSource } from '../../types/redux/checkout';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const SET_DEPOSIT_CHECKOUT_STATE = 'PAYMENT_WIDGET :: CHECKOUT :: SET_DEPOSIT_STATE';

export interface ISetDepositCheckoutStatePayload {
  paymentAmount: number;
  paymentInitSource: EPaymentInitSource;
  transactionId: string | undefined;
}

export type TSetDepositCheckoutStateAction = ITypedReduxAction<
  typeof SET_DEPOSIT_CHECKOUT_STATE,
  ISetDepositCheckoutStatePayload
>;

export const setDepositCheckoutState: (payload: ISetDepositCheckoutStatePayload) => TSetDepositCheckoutStateAction =
  actionGenerator<typeof SET_DEPOSIT_CHECKOUT_STATE, ISetDepositCheckoutStatePayload>(SET_DEPOSIT_CHECKOUT_STATE);
